import React, { useState, useEffect } from "react";
import Textarea from "shared/Textarea/Textarea";
import RadioGroup from "shared/RadioGroup/RadioGroup";
import MultiSelectDropdown from "shared/MultiSelectDropdown";
import FormItem from "./FormItem";
import { Grid2 as Grid } from "@mui/material";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import { Alert } from "@mui/material";
import api from "../../api";
import { updateUserBrand } from "../../redux/reducers/userReducer";
import { connect, useDispatch } from "react-redux";
import _ from 'lodash';

const BrandAgentRequiremntSection = ({ formoptions, selectedBrand }) => {
  const dispatch = useDispatch();
  const initialValues = {
    agent_commission_structure: selectedBrand.agent_commission_structure ?? "",
    agent_representation: selectedBrand.agent_representation ?? false,
    agent_regions: selectedBrand.agent_regions ?? [],
    agent_rep_regions: selectedBrand.agent_rep_regions ?? [],
    regions: selectedBrand.regions ?? [],
  };

  const [inputValues, setInputValues] = useState(initialValues);
  const [sbState, setSBState] = useState({
    open: false,
  });
  const { open } = sbState;

  useEffect(() => {
    const tempBrandData = _.cloneDeep(selectedBrand);
    tempBrandData.agent_regions = tempBrandData?.agent_regions?.map((r) => {
      return { value: r.region_id, label: r.region }
    });
    tempBrandData.agent_rep_regions = tempBrandData?.agent_rep_regions?.map((r) => {
      return { value: r.region_id, label: r.region }
    });

    setInputValues(tempBrandData);
  }, [selectedBrand])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    const payload = {
      id: 0,
      agent_commission_structure: "",
      agent_representation: false,
      agent_regions: [],
      agent_rep_regions: [],
    };

    payload.id = selectedBrand.id;
    payload.agent_commission_structure = inputValues.agent_commission_structure;
    payload.agent_representation = inputValues.agent_representation;
    payload.agent_regions = inputValues.agent_regions.map((region) => region.value);
    payload.agent_rep_regions = inputValues.agent_rep_regions.map((region) => region.value)

    api.updateBrandAgent(
      payload,
      (res) => {
        dispatch(updateUserBrand(res.data));
        openSuccessSnackbar({ vertical: 'bottom', horizontal: 'center' });
      }
    );
  };

  const openSuccessSnackbar = (position: SnackbarOrigin) => {
    setSBState({ ...position, open: true });
  };

  const handleCloseSB = () => {
    setSBState({ ...sbState, open: false });
  };

  const getRegions = () => {
    return formoptions?.regions?.map((r) => { return { value: r.id, label: r.name } })
  }

  const getAgentRepRegions = () => {
    const ids = inputValues.regions.map(item => item.region_id);
    
    return formoptions?.regions
      .filter(item => !ids.includes(item.id))
      .map((item) => { return { value: item.id, label: item.name } });
  }

  const handleAgentRegionUpdate = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      agent_regions: e,
    }));
  }

  const handleAgentRepRegionUpdate = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      agent_rep_regions: e,
    }));
  }

  const handleAgentRepRadioUpdate = (val) => {
    setInputValues((prevState) => ({
      ...prevState,
      agent_representation: val === "Yes" ? 1 : 0,
    }));
  }

  return (
    <>
      <div className="space-y-8">
        <h2 className="text-xl font-semibold">Minimum requirements for agents</h2>
        <FormItem label="Region">
          <MultiSelectDropdown
            options={getRegions()}
            onChange={handleAgentRegionUpdate}
            value={inputValues.agent_regions}
          />
        </FormItem>
        <FormItem label="Commission structure or other incentives">
          <Textarea
            name="agent_commission_structure"
            rows={5}
            value={inputValues?.agent_commission_structure ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <FormItem label="Are you looking for new representation?">
          <RadioGroup
            name="agent_representation"
            options={["Yes", "No"]}
            value={inputValues.agent_representation ? "Yes" : "No"}
            onChange={handleAgentRepRadioUpdate}
          />
        </FormItem>
        {inputValues?.agent_representation ?
          <FormItem label="New Representation Regions">
            <MultiSelectDropdown
              options={getAgentRepRegions()}
              onChange={handleAgentRepRegionUpdate}
              value={inputValues.agent_rep_regions}
            />
          </FormItem>
          : <></>}

        <Grid container direction={"row"} className={"fullWidth"}>
          <div className={"flex-1"}></div>
          <ButtonPrimary onClick={handleSaveChanges}>Save Changes</ButtonPrimary>
        </Grid>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSB}
        message="Agent Requirements Details Updated"
      >
        <Alert onClose={handleCloseSB} severity="success" variant="filled" sx={{ width: "100%" }}>
          Agent Requirements Details Saved Successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = (state) => ({
  formoptions: state.formoptions.options
});

export default connect(mapStateToProps, { updateUserBrand })(BrandAgentRequiremntSection);
